import { useEffect, useState } from "react";

const LINKS = [
  { id: "tila", label: "Tila" },
  { id: "kayttotarkoitukset", label: "Käyttö" },
  { id: "hinnasto", label: "Hinnasto" },
  { id: "sijainti", label: "Sijainti" },
  { id: "ukk", label: "UKK" },
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 z-40 w-full transition-colors duration-300 ${
        solid ? "bg-[#F7F4EE] shadow-[0_1px_20px_rgb(0,0,0,0.05)]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-8 lg:px-12">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className={`font-hand text-2xl transition-colors ${solid ? "text-[#2E2E2C]" : "text-[#F7F4EE]"}`}
        >
          Hengähdys
        </button>
        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className={`text-sm transition-colors ${
                solid ? "text-[#2E2E2C]/70 hover:text-[#8A9B87]" : "text-[#F7F4EE]/80 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={() => go("varaus")}
          data-testid="nav-cta"
          className={`rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-300 ${
            solid
              ? "bg-[#8A9B87] text-white hover:bg-[#A9805B]"
              : "border border-[#F7F4EE]/40 text-[#F7F4EE] hover:bg-[#F7F4EE]/10"
          }`}
        >
          Kysy aikoja
        </button>
      </nav>
    </header>
  );
};
